export default __webpack_public_path__ + "static/tick_1-b6eccd8b177b5b24f4186c87cac4e8a2.png";